export const OVERPAYMENT_NOT_CHANGEABLE_MESSAGE = 'A credit cannot be changed to an Overpayment credit.';
//# sourceMappingURL=overpayment-not-changeable-message.js.map